import { takeLatest, put, call } from "redux-saga/effects";
import slice, { FETCH_STRIPE_ADDONS } from "store/stripe/addons/slice";
import { getStripeAddons } from "resources/services/stripeService";

function* fetch({ meta }) {
  const { fetching, error, success, setStripeAddons } = slice.actions;

  yield put(fetching());
  try {
    const res = yield call(getStripeAddons);

    if (res.error) {
      throw new Error(res.error);
    }

    yield put(setStripeAddons(res));
    yield put(success());
    meta?.onSuccess && meta.onSuccess(res);
  } catch (e) {
    const errorMsg = e.message ? e.message : e;
    yield put(error(errorMsg));
    meta?.onError && meta.onError(errorMsg);
  }
}

export default function* watchFetchStripeAddons() {
  yield takeLatest(FETCH_STRIPE_ADDONS.type, fetch);
}
